module.exports = __webpack_public_path__ + "img/tooltip.c68f8d41.svg";